import { useCallback } from 'react';

function useCarouselNavigation(emblaApi, carouselRef) {
    /**
     * Function to scroll to the next slide or group of slides.
     * Handles both "fade" and "scroll" animations.
     */
    const scrollNext = useCallback(() => {
        if (emblaApi) {
            emblaApi.scrollNext();
        }
    }, [emblaApi]);
    const scrollPrev = useCallback(() => {
        if (emblaApi) {
            emblaApi.scrollPrev();
        }
    }, [emblaApi]);
    const handleKeyDown = (e) => {
        if (document.activeElement !== carouselRef.current) {
            return; // Ignore key presses if the container is not focused
        }
        if (e.key === "ArrowRight") {
            e.preventDefault();
            scrollNext();
        }
        else if (e.key === "ArrowLeft") {
            e.preventDefault();
            scrollPrev();
        }
    };
    return { scrollNext, scrollPrev, handleKeyDown };
}

export { useCarouselNavigation };
